module.exports = __webpack_public_path__ + "static/media/modalX.52450654.png";